var w3Items = [];
$.getJSON( "//lussoleather.ca/cdn/shop/t/40/assets/w3-images.json?v=184270137178755039371695544871", function( data ) {
	w3Items = data;
});
                        
function fieldAddedCallback(field, element){   
   if (element.hasClass('w3-images')){
      if (field.type =='radiobutton'){
        var w3Radios = element.find('input');
        $.each( w3Radios, function( index, input ) {
          var w3RadioValue = input.value; 
          var inputSpan = $(input).next();
          $(input).next().andSelf().wrapAll('<label class="options-radio" />');
          $('.w3-images').find('br').remove();
          if (w3Items[w3RadioValue] != undefined){ 
            if (w3Items[w3RadioValue].image != undefined){
              $('<img class="img-responsive" src="' + w3Items[w3RadioValue].image + '" /></a>' ).insertBefore(input);
          	}
            if (w3Items[w3RadioValue].linkURL != undefined){
              $('<a style="display:block;text-align:center;" target="_blank" href="' + w3Items[w3RadioValue].linkURL + '">View Here</a>' ).insertAfter(inputSpan);
            }
          }
        });
        $(element).find('.options-radio').wrapAll('<div class="custom-images" />');
        $(element).append('<div style="clear:both"></div>');
      }
   }
  
  $('label.options-radio input').change(function(){
    
    if($('label.options-radio input').is(':checked')){
      $(this).parent().find('img').addClass('focused');
      $(this).parent().siblings().find('img').removeClass('focused');
    }
    
  });
  
}
